export default __webpack_public_path__ + "static/media/core.52f99a70.png";